import { subDays, subMonths } from 'date-fns';
import { TypeProductionEnum } from './types-production';

export const PAGE_SIZE = 10;

// Mirrors Angular corp-period-filter.component.ts getDefaultPeriodByTypeProduction — default
// lookback window used to compute a report's default begin_date when none is provided.
// Shared across hooks that need a production-aware default period (monitor tab, index map
// generator download filter, etc.) so the mapping isn't duplicated per hook.
export const DEFAULT_PERIOD_DAYS_BY_PRODUCTION: Partial<Record<TypeProductionEnum, number>> = {
  [TypeProductionEnum.SWINES]: 130,
  [TypeProductionEnum.POULTRY]: 55,
};

// CORP-8247 ajuste 2: o Angular só usa janela em DIAS para Suínos e Aves; o caso default —
// que é o de Leite — é [PeriodInterval.LAST, PeriodUnit.MONTHS, 1], ou seja um mês de
// calendário. Assumir 30 dias corridos deslocava a data inicial de Lactação em um dia
// (02/07 vs 03/07 num mês de 31 dias).
export function defaultPeriodBeginDate(
  production: TypeProductionEnum | undefined,
  today: Date = new Date(),
): Date {
  const days = production ? DEFAULT_PERIOD_DAYS_BY_PRODUCTION[production] : undefined;
  return days === undefined ? subMonths(today, 1) : subDays(today, days);
}
